import {
  createHashRouter,
  Outlet,
  RouterProvider,
} from "react-router-dom";
import TextPage from './pages/text-page';
import TeamPage from './pages/team-page';
import Navbar, { Tab } from './header/navbar';
import Footer, { FooterNote } from './footer/footer';
import ImagesPage from './pages/images-page';
import Header from './header/header';
import { PubSection, PubsPage } from './pages/pubs-page';
import { useEffect, useState } from 'react';
import "./fonts.css"

const page_of = ( p : any) => {
  let title = p.title === undefined ? p.header : p.title;
  switch (p.type) {
    case "team":
      return <TeamPage title={title} team={p.members}/>
    case "text":
      return <TextPage title={title} body={text_of(p.body)}/>
    case "images": 
      let pars = p.paragraphs.map( (pp: { text: string | string[]; image: any; }) => {
        return {
          "text" : text_of(pp.text),
          "image" : pp.image
        }
      }  )

      return <ImagesPage title={title} paragraphs={pars}/>
    case "pub" : 
      let bib : PubSection[] = p.sections.map( (pp: { title: any; bib: any; }) => { return {title : pp.title, bib : pp.bib} } )
      return <PubsPage title={title} sections={bib} format={"apa"}/>
    default:
      return <TextPage title="Page incorrectly defined" body=""/>
  }
}


function text_of( text : string | string[]) {
    if(typeof text == "string")
      return text;
    else 
      return text.join("\n\n");
} 

const PageBody = ({tabs, headerText, headerImage, footer} : {tabs : Tab[], headerText : string, headerImage : string, footer : FooterNote[] }) => {
  return <>
   <Header body={text_of(headerText)} image={headerImage}/>
   <Navbar tabs={tabs}/>
   <Outlet/>  
   <Footer tabs={tabs} footer_notes={footer}/>
  </>
}


function App() {

  const [config, setConfig] = useState<any>(undefined)

  // let config = undefined 

  useEffect( () => {
      fetch("/config.json")
      .then( (response) => response.json() )
      .then( (json) => {
        setConfig(json);
      })}, [])

  if(config === undefined)
    return <></>
    

  let home_tab : Tab = { header : config.home.header, path : "/" };
  let tabs : Tab[] = config.pages.map( (p: { header: any; path: any; }) => {return { header: p.header, path : p.path } });
  tabs.unshift(home_tab);

  const router = createHashRouter([
    {
      path : "/",
      element : <PageBody tabs={tabs} headerText={config.header.text} headerImage={config.header.image} footer={config.footer}/>,
      children : [
        {
          path : "/",
          element : <TextPage title={config.home.title} body={text_of(config.home.body)}/>
        },
        ...config.pages.map( (p: { path: string | undefined; }) => {
          return {
            path : p.path,
            element : page_of(p)
          }; 
        })
      ]
    },
  ]);


  return <RouterProvider router={router} />
}

export default App;
